import "./AllVendors.scss";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Assessment/Header/Header";
import { useTranslation } from "react-i18next";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import {
  AssessmentCheckboxRadio,
  TemplateSearch,
  Pagination,
  DetailedListItem,
  AssessmentButton,
  SkeletonList,
  SearchTypeSelect,
  InputField,
  showToast,
} from "ui-components";
import { setSessionStorageItem } from "../../utils/SessionStorageMethod/setSessionStorageItem";
import { convertDate, copyText, emailRegex } from "../../utils/Common/Constant";
import {
  getPartnerInvitationsList,
  InvitePartner,
} from "../../service/StaffAugumentation/StaffAugumentationApis";
import useDebounce from "../../utils/Hooks/useDebounce";
import EmailIcon from "../../utils/Images/EmailIcon";
import DataNotAvailable from "../../utils/DataNotFound/DataNotAvailable";
import { ResponseScreenEnums } from "../../utils/Enums/ResponseScreenEnums";
import CustomModal from "../../components/CustomModal/CustomModal";
import Loader from "../../components/Loader/Loader";
import { staffAugSettingsDetails } from "../../service/Settings/Settings";
import DocumentIcon from "../../utils/Images/DocumentIcon";
const AllVendors = () => {
  const [isResetDisable] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [managePaginationRef, setManagePaginationRef] = useState<any>(null);
  const [locationFilter, setLocationFilter] = useState("");
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const status = searchParams.get("st") ?? ResponseScreenEnums.STATUS_ALL;
  const searchText = searchParams.get("search") || "";
  const debounceSearchText = useDebounce(searchText, 400);
  const currentPage = searchParams.get("page")
    ? Number(searchParams.get("page"))
    : 1;
  const [vendorList, setVendorList] = useState<any>([]);
  const paginaionRef = useRef<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showInviteBox, setShowInviteBox] = useState(false);
  const [email, setEmail] = useState("");
  const [isInvalidEmail, setIsInvalidEmail] = useState(false);
  const [inviteBtnLoading, setInviteBtnLoading] = useState(false);
  // send invitation
  const sendInvitation = async () => {
    const data = {
      emailId: email,
    };
    setInviteBtnLoading(true);
    try {
      const sendInvitationRes = await InvitePartner(data);
      if (sendInvitationRes?.data?.status === 200) {
        showToast(sendInvitationRes?.data?.customMessage, "success");
        getPartnerInvitedList();
        setEmail("");
        setShowInviteBox(false);
      } else {
        showToast(sendInvitationRes?.data?.customMessage, "error");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setInviteBtnLoading(false);
    }
  };
  useEffect(() => {
    if (paginaionRef.current && managePaginationRef != null) {
      paginaionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [managePaginationRef]);
  const handleFilter = ({ type, value }: any) => {
    let params: Record<string, any> = {
      st: status,
      page: currentPage,
      search: searchText,
    };

    switch (type) {
      case "status":
        params = {
          ...params,
          st: value,
          page: !isResetDisable ? currentPage : 1,
        };
        break;
      case "page":
        params = { ...params, page: value };
        break;
      case "search":
        params = { ...params, search: value, page: 1 };
        break;
    }
    const queryString = new URLSearchParams(params).toString();
    navigate(`?${queryString}`);
  };
  useEffect(() => {
    getPartnerInvitedList();
  }, [currentPage, pageSize, debounceSearchText, status]);

  const getPartnerInvitedList = async () => {
    setIsLoading(true);
    const getPartnerList: any = await getPartnerInvitationsList(
      debounceSearchText,
      status,
      currentPage,
      pageSize,
    );
    if (getPartnerList?.status === 200) {
      setTotalCount(getPartnerList?.data?.totalCount);
      setVendorList(getPartnerList?.data?.data);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const handleViewClick = (partnerCompanyId: string) => {
    navigate(`/${currentLanguage}/contracts?vendorId=${partnerCompanyId}`);
  };

  const locationOptions = [
    { label: t("GENERAL.BOTH"), value: "" },
    ...Array.from(
      new Set(vendorList.map((v: { country: string }) => v.country)),
    ).map((location) => ({
      label: location,
      value: location,
    })),
  ];
  const validateEmail = (email: string) => {
    return emailRegex.test(email);
  };
  const handlePass = (
    partnerCompanyId: string,
    partnerUserName: string,
    logo: string,
  ) => {
    navigate(`/${currentLanguage}/documentReview/${partnerCompanyId}`, {
      state: { vendorName: partnerUserName, vendorLogo: logo },
    });
  };

  const [getSettingDetails, setGetSettingDetails] = useState<any>();
  const getSettingsDetailsApi = async () => {
    try {
      const res = await staffAugSettingsDetails();
      if (res?.status === 200) {
        setGetSettingDetails(res?.data);
      }
    } catch (error) {
      console.error("Error fetching settings details:", error);
    }
  };
  // Auto Focus in input field
  const inputRef = useRef<HTMLInputElement | null>(null);
  useEffect(() => {
    if (showInviteBox && inputRef.current) {
      inputRef.current.focus();
    }
  }, [showInviteBox]);
  return (
    <>
      <Header />
      <div className="minHeight100 vendorList">
        <div className="container-fluid">
          <div className="vendorScanningLeftSide" ref={paginaionRef}>
            <div className="d-flex align-item-center justify-content-between mt-5 vendorHeader">
              <h2 className="mb-4">{t("RESUME.VENDORS")}</h2>
              <div>
                <AssessmentButton
                  className="whiteBtn"
                  onClick={() => {
                    setShowInviteBox(!showInviteBox);
                    getSettingsDetailsApi();
                  }}
                >
                  {t("RESUME.INVITE_VENDOR")}
                </AssessmentButton>
              </div>
            </div>
            <div className="vendorFilterSection">
              <div className="filterVendor">
                <div className="checkbox">
                  <div className="d-flex gap-3">
                    <div
                      className="checkboxWithLabel"
                      onClick={() => {
                        handleFilter({
                          type: "status",
                          value: ResponseScreenEnums.STATUS_ALL,
                        });
                      }}
                    >
                      <AssessmentCheckboxRadio
                        type="radio"
                        checked={status === ResponseScreenEnums.STATUS_ALL}
                      />
                      <p className="radioCheckLabel">{t("VENDOR.ALL")}</p>
                    </div>
                    <div
                      className="checkboxWithLabel"
                      onClick={() => {
                        handleFilter({
                          type: "status",
                          value: ResponseScreenEnums.STATUS_ACCEPTED,
                        });
                      }}
                    >
                      <AssessmentCheckboxRadio
                        type="radio"
                        checked={status === ResponseScreenEnums.STATUS_ACCEPTED}
                      />
                      <p className="radioCheckLabel">{t("VENDOR.ACCEPTED")}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="searchWithNew">
                <TemplateSearch
                  onChange={(e) => {
                    handleFilter({ type: "search", value: e });
                  }}
                  iconName="searchList"
                  placeholder={t("VENDOR.SEARCH_VENDOR")}
                  value={searchText ?? ""}
                />
              </div>
              <div className="locationSearch">
                <SearchTypeSelect
                  label={t("GENERAL.COMPANY_LOCATION")}
                  options={locationOptions}
                  value={locationFilter}
                  placeholder={t("VENDOR.LOCATION_SEARCH")}
                  onChange={(value: any) => {
                    setLocationFilter(value);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="vendorCards">
            <p className="totalVendors">
              {t("VENDOR.TOTAL_VENDOR")} : {totalCount}
            </p>
            {isLoading ? (
              <>
                {Array.from({ length: 5 }).map((_, index) => (
                  <SkeletonList
                    key={`skeleton-${index}`}
                    numberOfTitles={1}
                    numberofTextLines={5}
                    titleSize={18}
                    textSize={12}
                    thumbnailHeight={250}
                    thumbnailWidth={250}
                    itemsGap={20}
                  />
                ))}
              </>
            ) : vendorList?.length ? (
              vendorList.map((item: any, ind: number) => (
                <div key={ind}>
                  <DetailedListItem
                    details={[
                      {
                        label: t("GENERAL.COMPANY"),
                        value: item?.displayName ? item?.displayName : "-",
                      },
                      {
                        label: t("GENERAL.RESOURCES"),
                        value:
                          item?.totalResources === "0"
                            ? "-"
                            : item?.totalResources,
                      },
                      {
                        label: t("GENERAL.COMPANY_LOCATION"),
                        value: `${item?.city}, ${item?.country}`,
                      },
                      {
                        label: t("RESUME.CONTRACTS"),
                        value: item?.contracts === "0" ? "-" : item?.contracts,
                      },
                    ]}
                    statusText={
                      item?.status === ResponseScreenEnums.STATUS_ACCEPTED
                        ? ""
                        : item?.status
                    }
                    statusType={convertDate(
                      item?.invitationSentAt,
                      false,
                      true,
                    )}
                    title={item?.partnerUserName ? item?.partnerUserName : "-"}
                    titleBelow={
                      <div className="listTitleBelowSec">
                        <div>
                          <EmailIcon />
                        </div>
                        <span
                          className="titleBelowContent cursorPointer"
                          title={item?.emailId}
                          onClick={() => copyText(item?.emailId)}
                        >
                          {item?.emailId ?? "-"}
                        </span>
                      </div>
                    }
                    statusIcon={item?.logo}
                    actionButtonText={t("CONTRACT.DOCUMENTS")}
                    onActionClick={() => {
                      handlePass(
                        item?.partnerCompanyId,
                        item?.partnerUserName,
                        item?.logo,
                      );
                    }}
                    secondaryButtonText={t("GENERAL.VIEW")}
                    onSecondaryClick={() => {
                      handleViewClick(item?.partnerCompanyId);
                    }}
                    columnCount={3}
                  />
                </div>
              ))
            ) : (
              <div className="p-5">
                <DataNotAvailable />
              </div>
            )}
          </div>
          <div className="row">
            <div className="col-md-12">
              <Pagination
                className="pagination-bar"
                currentPage={Number(currentPage)}
                totalCount={totalCount > pageSize ? totalCount : 0}
                pageSize={pageSize}
                onPageChange={(page: number) => {
                  handleFilter({ type: "page", value: page });
                  setSessionStorageItem("jobListPage", page);
                  setManagePaginationRef(Math.random());
                }}
                ofLabel={t("GENERAL.OF")}
                resultLabel={t("GENERAL.RESULTS")}
                setPageSize={setPageSize}
              />
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <CustomModal
        show={showInviteBox}
        isCrossBtn={true}
        isHeaderVisible={false}
        handleClose={() => {
          setShowInviteBox(false);
          setEmail("");
        }}
        size="lg"
        fullscreen="md-down"
        isFooterVisible={false}
        className="inviteVendorPopup"
      >
        <div>
          <div className="inviteBox">
            <h3 className="inviteTitle">{t("RESUME.INVITE_VENDOR")}</h3>
            <div className="emailInput">
              <InputField
                type="email"
                placeholder={t("GENERAL.EMAIL")}
                value={email}
                onChange={(e: any) => {
                  setIsInvalidEmail(validateEmail(e.trim()));
                  setEmail(e);
                }}
                additionalProps={{
                  ref: (el: HTMLInputElement) => {
                    inputRef.current = el;
                  },
                  onKeyDown: (e: any) => {
                    if (e.key === "Enter") {
                      sendInvitation();
                    }
                  },
                }}
              />
              {email && !isInvalidEmail && (
                <div className="errorMessage">
                  {t("ERROR.INVALID_EMAIL_ADDRESS")}
                </div>
              )}
            </div>
            {getSettingDetails?.vendorOnboardingRequirements?.length ? (
              <div className="vendorDoc">
                <h5 className="mt-4 mb-3">{t("Required documents")}</h5>
                <div className="reqDocList">
                  {getSettingDetails?.vendorOnboardingRequirements?.map(
                    (item: any, ind: number) => (
                      <div className="contractDocList d-flex gap-2" key={ind}>
                        <DocumentIcon />
                        <h6>
                          {item?.title}
                          {item?.isMandatory === true ? <span>*</span> : ""}
                        </h6>
                      </div>
                    ),
                  )}
                </div>
              </div>
            ) : null}
            <div className="inviteVendorBtns">
              {inviteBtnLoading ? (
                <AssessmentButton
                  disabled={true}
                  className="whiteBtn inviteBtn"
                  onClick={sendInvitation}
                >
                  <div className="loadingBtn">
                    {t("GENERAL.PLEASE_WAIT")}
                    <Loader />
                  </div>
                </AssessmentButton>
              ) : (
                <AssessmentButton
                  disabled={!email || !isInvalidEmail}
                  className="whiteBtn inviteBtn"
                  onClick={sendInvitation}
                >
                  {t("GENERAL.INVITE")}
                </AssessmentButton>
              )}
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default AllVendors;
